/* Opening-hours badge for the contact channel sections.
   Evaluated in America/New_York so it matches the published support hours
   regardless of where the visitor is. */
(function () {
  function hoursET(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }).formatToParts(now);
    var get = function (type) {
      var p = parts.find(function (x) { return x.type === type; });
      return p ? p.value : '';
    };
    return {
      weekday: get('weekday'),
      hour: (parseInt(get('hour'), 10) % 24) + parseInt(get('minute'), 10) / 60
    };
  }

  function sync() {
    var now = new Date();
    var et = hoursET(now);
    var isWeekday = ['Sat', 'Sun'].indexOf(et.weekday) === -1;

    document.querySelectorAll('[data-cc-status]').forEach(function (el) {
      var open = parseFloat(el.dataset.openHour);
      var close = parseFloat(el.dataset.closeHour);
      var weekdaysOnly = el.dataset.weekdaysOnly === 'true';
      var isOpen = et.hour >= open && et.hour < close && (!weekdaysOnly || isWeekday);
      var label = isOpen ? el.dataset.openLabel : el.dataset.closedLabel;
      var text = el.querySelector('[data-cc-status-text]');

      el.setAttribute('data-open', isOpen ? 'true' : 'false');
      if (text && label) text.textContent = label;
    });
  }

  sync();
  setInterval(sync, 60000);
})();
